<MenuItem iconF7="rectangle_stack_badge_minus" iconOnly {iconSize} dropdown on:menuOpened={buildDropdown}>
  <MenuDropdown left>
    {#each children as child (child.id) }
    <MenuDropdownItem href="#" text={child.id} onClick={() => handleClick(child.id)} />      
    {/each}
  </MenuDropdown>
</MenuItem>

<style>
  *, *::before, *::after {
    box-sizing: border-box;
  }</style>

<script lang="ts">import { MenuItem, MenuDropdown, MenuDropdownItem } from 'framework7-svelte';
import './CardsEditorComponentInterfaces';
import { CardsPageContextKey } from './context';
import { getContext } from 'svelte';
export let iconSize = 20;
const pageContext = getContext(CardsPageContextKey);
const selectedComponentStore = pageContext.editorModeManager.getSelectedComponentStore();
$: selectedComponent = $selectedComponentStore;
let children = [];
function buildDropdown() {
    children = (selectedComponent === null || selectedComponent === void 0 ? void 0 : selectedComponent.getChildren()) || [];
}
function handleClick(id) {
    selectedComponent === null || selectedComponent === void 0 ? void 0 : selectedComponent.removeChild(id);
}
</script>